import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import useApi from "../../hook/useApi";

const UpdateTradeModal = ({ show, onHide, trade, onSuccess }) => {
  const { AsyncPatchApiCall } = useApi();

  const [form, setForm] = useState({});

  useEffect(() => {
    if (trade) {
      setForm({
        symbol: trade.symbol,
        script: trade.script,
        exchange: trade.exchange,
        segment: trade.segment,
        expiry: trade.expiry || "",
        orderType: trade.orderType,
        side: trade.side,
        lotSize: trade.lotSize,
        quantity: trade.quantity,
        orderPrice: trade.orderPrice,
        inputLot: trade.inputLot,
        stopLoss: trade.stopLoss || "",
        targetPrice: trade.targetPrice || "",
        closeReason: "",
      });
    }
  }, [trade]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]:
        name.includes("Price") ||
        name.includes("quantity") ||
        name.includes("lot")
          ? Number(value)
          : value,
    }));
  };

  const handleSubmit = async () => {
    if (!trade?._id) return;

    const res = await AsyncPatchApiCall(
      `/orders/update-order/${trade._id}`,
      form,
    );

    if (res?.success) {
      toast.success("Trade updated successfully");
      onHide();
      onSuccess(); // refresh trades
    } else {
      toast.error(res?.message || "Update failed");
    }
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      centered
      contentClassName="border-0"
    >
      <Modal.Header closeButton>
        <Modal.Title>Update Trade</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="row g-3">
          <div className="col-md-6">
            <label>Symbol</label>
            <input
              className="form-control"
              name="symbol"
              value={form.symbol || ""}
              onChange={handleChange}
            />
          </div>

          <div className="col-md-6">
            <label>Segment</label>
            <input
              className="form-control"
              name="segment"
              value={form.segment || ""}
              onChange={handleChange}
            />
          </div>

          <div className="col-md-6">
            <label>Order Type</label>
            <select
              className="form-control"
              name="orderType"
              value={form.orderType || ""}
              onChange={handleChange}
            >
              <option value="MARKET">MARKET</option>
              <option value="LIMIT">LIMIT</option>
              <option value="STOP">STOP</option>
              <option value="CF">CF</option>
            </select>
          </div>

          <div className="col-md-6">
            <label>Side</label>
            <select
              className="form-control"
              name="side"
              value={form.side || ""}
              onChange={handleChange}
            >
              <option value="BUY">BUY</option>
              <option value="SELL">SELL</option>
            </select>
          </div>

          <div className="col-md-4">
            <label>Lot Size</label>
            <input
              type="number"
              className="form-control"
              name="lotSize"
              value={form.lotSize || ""}
              onChange={handleChange}
            />
          </div>

          <div className="col-md-4">
            <label>Quantity</label>
            <input
              type="number"
              className="form-control"
              name="quantity"
              value={form.quantity || ""}
              onChange={handleChange}
            />
          </div>

          <div className="col-md-4">
            <label>Price</label>
            <input
              type="number"
              className="form-control"
              name="orderPrice"
              value={form.orderPrice || ""}
              onChange={handleChange}
            />
          </div>

          <div className="col-md-6">
            <label>Stop Loss</label>
            <input
              type="number"
              className="form-control"
              name="stopLoss"
              value={form.stopLoss || ""}
              onChange={handleChange}
            />
          </div>

          <div className="col-md-6">
            <label>Target</label>
            <input
              type="number"
              className="form-control"
              name="targetPrice"
              value={form.targetPrice || ""}
              onChange={handleChange}
            />
          </div>

          <div className="col-12">
            <label>Reason</label>
            <input
              className="form-control"
              name="closeReason"
              value={form.closeReason || ""}
              onChange={handleChange}
            />
          </div>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <button className="btn btn-secondary" onClick={onHide}>
          Cancel
        </button>
        <button className="btn btn-primary" onClick={handleSubmit}>
          Update Trade
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default UpdateTradeModal;
